<div class="row option-row">
  <div class="col-xs-12 col-md-2 interest-rate" [ngClass]="{'col-lg-3': advanceEmiCount < 1}">
    {{option.effectiveRateOfInterest | round: 2}}%
    <span class="interest-rate-text">Interest</span>
  </div>

  <div *ngIf="advanceEmiCount > 0" class="col-xs-12 col-md-2 col-lg-3">
    <p class="loan-amount">{{balanceAmount | round | indianCurrency}}</p>
    <p class="loan-amount-label">{{advanceEmiCount}} advance EMIs</p>
    <p class="loan-amount-label">( Rounded down to the nearest {{1000 | indianCurrency}} )</p>
  </div>

  <div class="col-xs-12 col-md-3 col-lg-3">
    <p class="loan-amount">{{option.amount | round | indianCurrency}}</p>
    <p class="loan-amount-label">{{option.tenure}} EMIs</p>
    <p class="loan-amount-label"><span  *ngIf="advanceEmiCount > 0">( Rounded up to the nearest {{1000 | indianCurrency}} )</span></p>
  </div>

  <div class="col-xs-12 col-md-3" [ngClass]="{'col-lg-2': advanceEmiCount > 0, 'col-lg-3': advanceEmiCount < 1}">
    <p class="emi">{{option.emi | round | indianCurrency}} x {{option.tenure}} m</p>
    <p class="loan-amount-label">EMI Payment</p>
    <p class="loan-amount-label">( Approximate )</p>
  </div>

  <div class="col-xs-12 col-md-2 apply-button-container">
    <button class="apply-now apply-button" (click)="apply(option)">Apply</button>
  </div>
</div>
